import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Input, Select, Divider, Table, Image, Button } from 'antd';
import Swal from 'sweetalert2';
import { fetchData, sendData, sendDataPut } from '../../httpRequests';
import Search from 'antd/lib/transfer/search';
import { useParams } from 'react-router-dom';


const filterCategory = {
    filterCategory_id: 0,
}
export default function AddProductPharmacies() {
    const [categorys, setCategorys] = useState([]);
    const [formValuesCategories, setFormValuesCategories] = useState(filterCategory)

    const [products, setProducts] = useState([]);
    const [productQuantity, setProductQuantity] = useState(0)

    const [initial, seIinitial] = useState(0)
    const [limit, setLimit] = useState(10)
    const [selectCurrent, setSelectCurrent] = useState(1)
    const [selectCategorie, setSelectCategorie] = useState(0)
    const [selectImage, setSelectImage] = useState(0)

    const [tbLoading, setTbLoading] = useState(false)
    const [text, setText] = useState('')

    const { id } = useParams();
    const [pharmaciy_id, setPharmaciy_id] = useState((id)?id:Number(localStorage.getItem('PHARMACY_LOGGED')))
    const { filterCategory_id } = formValuesCategories

    useEffect(() => {
        getProducts()
        getCategorys()


    }, [])

    const getCategorys = () => {
        const url = '/categories/getCategories';
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const categories = response['category'];
                let allCategory = categories
                allCategory.unshift({ id: 0, name: 'All' })
                setCategorys(allCategory)
            }
        })
    }
    const getProducts = () => {
        setTbLoading(true)
        const url = `/products/getProductsWithCategoryToAddPharmacies/${limit}/${initial}/${selectCategorie}/${pharmaciy_id}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['products'];
                setProducts(products)
                // setFilteredProducts(products)
                setProductQuantity(response.productQuantity)
                // console.log(productQuantity, "ddd")
            }
            setTbLoading(false)
        })
    }

    const onSearch = (value) => {
        // setProducts([])
        // setFilteredProducts([])
        seIinitial(0)
        setLimit(10)
        setSelectCurrent(1)
        setSelectCategorie(0)
        setSelectImage(0)


        setSelectImage(0)

        let texto = value.target.value
        setText(texto)

        const url = `/products/getProduSearchToAddPharmacies/${limit}/${0}/${pharmaciy_id}`;
        if (texto != '') {
            sendData(url, { text: texto.trim() }).then((response) => {
                setProducts(response.product)
                setProductQuantity(response.productQuantity)
            })
        } else {
            getProducts()
        }

    }

    const handleFilter = async (e) => {
        setText('')
        seIinitial(0)
        setSelectCurrent(1)
        setSelectCategorie(e)


        setFormValuesCategories({
            ...formValuesCategories,
            filterCategory_id: e

        })

        setTbLoading(true)
        const url = `/products/getProductsWithCategoryToAddPharmacies/${limit}/${initial}/${e}/${pharmaciy_id}`;
        fetchData(url).then((response) => {
            if (Object.keys(response).length > 0) {
                const products = response['products'];
                setProducts(products)
                setProductQuantity(response.productQuantity)
                console.log(productQuantity, "ddd")
            }
            setTbLoading(false)
        })
    }

    const handlePa = async (value, value2) => {
        setLimit(value.pageSize)
        setSelectCurrent(value.current)

        let takedValue;
        if (value.current == 1) {
            takedValue = 0
            seIinitial(0)
        } else {
            takedValue = 10 * value.current -10
            console.log(takedValue)
            seIinitial(takedValue)
        }

        if (text == '') {
            setTbLoading(true)
            const url = `/products/getProductsWithCategoryToAddPharmacies/${value.pageSize}/${takedValue}/${selectCategorie}/${pharmaciy_id}`;
            fetchData(url).then((response) => {
                if (Object.keys(response).length > 0) {
                    const products = response['products'];
                    setProducts(products)
                    setProductQuantity(response.productQuantity)
                }
                setTbLoading(false)
            })
        } else {
            setTbLoading(true)
            const url = `/products/getProduSearchToAddPharmacies/${value.pageSize}/${takedValue}/${pharmaciy_id}`;
            sendData(url, { text }).then((response) => {
                console.log(response.product)

                setProducts(response.product)
                setProductQuantity(response.productQuantity)
            })
            setTbLoading(false)
        }
    }

    const addProductToPharmacy = (productId) => {
        const url = '/products/createProductExistForPharmacy';
        // const pharmacyId = getPharmacyId();
        const data = {
            pharmacy_id: pharmaciy_id,
            product_id: productId,
            stock: 0,
            price: 0.0,
            ivu_status: 0,
            created_by: '',
            gift_price: 0,
            gift_status: 0
        };
        sendDataPut(url, data).then((response) => {
            console.log(response)
            if (Object.keys(response).length > 0) {
                // 	Swal.fire({
                // 		text: response['message'],
                // 		icon: 'success',
                // 		confirmButtonColor: '#128780'
                // 	}).then(() => loadCategories());
                getProducts()
                setText('')
            }
        });
    };

    const columns = [
        {
            title: '',
            render: ({ img }) => (
                <div
                    style={{
                        width: 40
                    }}
                >
                    <Image src={img} />
                </div>
            )
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.name.localeCompare(b.name)
        },
        { title: 'Category', dataIndex: 'category_name', key: 'category_id' },
        {
            title: 'Action',
            render: ({ pharmacy_status, id }) => (

                <Button
                    onClick={() => addProductToPharmacy(id)}
                    type='primary'
                    style={{ borderRadius: 10, height: 35, width: 150 }}
                    size='small'
                >
                    Add
                </Button>
            )
        }
    ];

    return (
        <div>
            <Row gutter={24}>
                <Col span={12}>
                    {/* <Search style={{ width: '100%' }} size='large' placeholder='Search product by name'  /> */}
                    <Input
                        size='large'
                        type='text'
                        name="texto"
                        value={text}
                        onChange={onSearch}
                        placeholder='Search Product'
                    />
                </Col>
                <Col span={12}>
                    <Select style={{ width: '100%' }} defaultValue={filterCategory_id} size='large' name="category_id" value={filterCategory_id} onChange={handleFilter}>
                        {categorys.map((c) => (
                            <Select.Option key={c.id} value={c.id}  >
                                {c.name}
                            </Select.Option>
                        ))
                        }
                    </Select>
                </Col>
            </Row>
            <Divider />

            <Row gutter={24}>
                <Col span={24}>
                    <Table columns={columns} dataSource={products} loading={tbLoading} rowKey={(item) => item.id}
                        pagination={{ pageSize: limit, total: productQuantity, current: selectCurrent }} onChange={handlePa}
                    />
                </Col>
            </Row>
        </div>
    )
}